import React, { memo, useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './SoftCardThreePart.module.less';
import { hasClass, removeClass, addClass, changeClass, formatMoney } from '../../utils/utils';
import _LogInView from '../_LogInView/_LogInView';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const descRef = useRef(null);
  const imgRef = useRef(null);
  const gifRef = useRef(null);
  const optRef = useRef(null);
  const optPayRef = useRef(null);

  const [isShowGif, setIsShowGif] = useState(false);

  const handleSoftCard = useCallback(() => {
    // 小banner点击
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfo.source_p,
          source_pp: logInfo.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfo.source || 'SoftCardThreePart_Source_Err',
        source_pp: logInfoData.source_p,
      }),
    );

    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  }, [dispatch, logInfo, history]);

  const onMouseOver = useCallback(
    e => {
      if (descRef && descRef.current) {
        changeClass(descRef.current, styles.mouse_out, styles.mouse_in);
      }
      if (optRef && optRef.current) {
        changeClass(optRef.current, styles.mouse_in, styles.mouse_out);
      }
      if (optPayRef && optPayRef.current) {
        changeClass(optPayRef.current, styles.mouse_in, styles.mouse_out);
      }

      if (gifRef && gifRef.current) {
        setIsShowGif(true);
        const gifDom = gifRef.current;
        gifDom.style.display = 'flex';
        changeClass(gifDom, styles.gif_in, styles.gif_out);
        return;
      }
      if (imgRef && imgRef.current) {
        const imgDom = imgRef.current;
        addClass(imgDom, styles.image_mouse_in);
      }
    },
    [imgRef, optRef, optPayRef, descRef],
  );

  const onMouseLeave = useCallback(
    e => {
      if (descRef && descRef.current) {
        changeClass(descRef.current, styles.mouse_in, styles.mouse_out);
      }
      if (optRef && optRef.current) {
        changeClass(optRef.current, styles.mouse_out, styles.mouse_in);
      }
      if (optPayRef && optPayRef.current) {
        changeClass(optPayRef.current, styles.mouse_out, styles.mouse_in);
      }

      if (gifRef && gifRef.current) {
        setIsShowGif(false);
        const gifDom = gifRef.current;
        changeClass(gifDom, styles.gif_out, styles.gif_in);
        gifDom.style.display = 'none';
        // 小banner hover
        dispatch(
          logging({
            category: 'C',
            action: 'Hover_Video_SoftCard',
            label: '',
            param2: {
              source: logInfo.source || 'SoftCardThreePart_Source_Err',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              softID: soft.androidType === '1' ? soft.packageName : soft.softID,
              softType: soft.androidType === '1' ? 1 : 0,
            },
          }),
        );
        return;
      }
      if (imgRef && imgRef.current) {
        const imgDom = imgRef.current;
        addClass(imgDom, styles.image_mouse_out);
      }
    },
    [imgRef, optRef, optPayRef, descRef],
  );

  const onAnimationEnd = useCallback(
    e => {
      if (imgRef && imgRef.current) {
        const imgDom = imgRef.current;
        if (hasClass(imgDom, styles.image_mouse_out)) {
          removeClass(imgDom, styles.image_mouse_in);
          removeClass(imgDom, styles.image_mouse_out);
        }
      }
      if (optRef && optRef.current) {
        const optDom = optRef.current;
        if (hasClass(optDom, styles.mouse_out)) {
          removeClass(optDom, styles.mouse_in);
          removeClass(optDom, styles.mouse_out);
        }
      }
    },
    [imgRef, optRef],
  );

  const formatDiscount = (current, original) => {
    let cp = parseFloat(current);
    let op = parseFloat(original);
    if (cp > 0 && op > 0) {
      let discont = parseFloat((cp / op) * 10).toFixed(1);
      if (discont.indexOf('.0') > -1) {
        return discont.slice(0, discont.length - 2);
      }
      return discont;
    }
    return '0';
  };

  return (
    <_LogInView cardData={soft} logInfo={logInfo}>
      <div
        className={styles.soft_card}
        onMouseOver={e => onMouseOver(e)}
        onMouseLeave={e => onMouseLeave(e)}
        onAnimationEnd={e => onAnimationEnd(e)}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <div className={styles.soft_card_img_}>
          <img className={styles.soft_card_img} src={soft?.ztImg} alt="" ref={imgRef} />
          {soft?.hoverShow === 1 && soft?.resUrl && <div className={styles.soft_img_gif} />}
          {soft?.hoverShow === 1 && soft?.resUrl && (
            <div className={styles.soft_git_box} ref={gifRef}>
              {isShowGif && <img className={styles.soft_git} src={soft?.resUrl} alt="" />}
            </div>
          )}
        </div>

        {soft?.payType === 1 ? (
          <div className={styles.soft_card_info}>
            <div className={styles.soft_card_info_img_}>
              <img className={styles.soft_card_info_img} src={soft?.logoFile} alt="" />
              {soft?.androidType === '1' && <div className={styles.soft_card_info_logo} />}
            </div>
            <div className={styles.soft_card_infos_pay}>
              <div
                className={styles.soft_card_infos_name_pay}
                title={(soft?.softName && soft?.softName?.length) > 8 ? soft?.softName : ''}
              >
                {soft?.softName}
              </div>
              <div
                ref={descRef}
                className={styles.soft_card_infos_desc_pay}
                title={
                  (soft?.introduction && soft?.introduction?.length) > 8 ? soft?.introduction : ''
                }
              >
                {soft?.introduction || ''}
              </div>
              <div
                className={styles.soft_card_infos_opt_pay}
                ref={optPayRef}
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                <Button
                  soft={soft}
                  info={{
                    className: styles.soft_button,
                    className_busing: styles.soft_button_busing,
                    className_open: styles.soft_button_open,
                  }}
                  // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
                  logInfo={{ ...logInfo }}
                />
              </div>
            </div>

            <div
              className={styles.soft_buyInfos}
              onClick={e => {
                e.stopPropagation();
              }}
            >
              {soft?.originalPrice &&
                soft?.currentPrice &&
                soft?.originalPrice !== soft?.currentPrice && (
                  <>
                    <div className={`soft_buyInfos_zk`}>
                      {`${formatDiscount(soft?.currentPrice, soft?.originalPrice)}折`}
                    </div>
                    <div className={`soft_buyInfos_price`}>
                      <div className={`soft_buyInfos_cp`}>
                        <span className={`soft_buyInfos_cp_1`}>￥</span>
                        <span className={`soft_buyInfos_cp_2`}>
                          {formatMoney(parseFloat((soft?.currentPrice || 0) / 100))}
                        </span>
                      </div>
                      <div className={`soft_buyInfos_op`}>
                        ￥{formatMoney(parseFloat((soft?.originalPrice || 0) / 100))}
                      </div>
                    </div>
                  </>
                )}

              {((!soft?.originalPrice && soft?.currentPrice) ||
                (soft?.originalPrice && !soft?.currentPrice) ||
                (soft?.originalPrice &&
                  soft?.currentPrice &&
                  soft?.originalPrice === soft?.currentPrice)) && (
                <>
                  <div className={`soft_buyInfos_zk_`}></div>
                  <div className={`soft_buyInfos_price`}>
                    <div className={`soft_buyInfos_cp`}>
                      <span className={`soft_buyInfos_cp_1`}>￥</span>
                      <span className={`soft_buyInfos_cp_2`}>
                        {formatMoney(
                          parseFloat((soft?.currentPrice || soft?.originalPrice || 0) / 100),
                        )}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <div className={styles.soft_card_info}>
            <div className={styles.soft_card_info_img_}>
              <img className={styles.soft_card_info_img} src={soft?.logoFile} alt="" />
              {soft?.androidType === '1' && <div className={styles.soft_card_info_logo} />}
            </div>

            <div className={styles.soft_card_infos}>
              <div
                className={styles.soft_card_infos_name}
                title={(soft?.softName && soft?.softName?.length) > 8 ? soft?.softName : ''}
              >
                {soft?.softName}
              </div>
              <div
                ref={descRef}
                className={styles.soft_card_infos_desc}
                title={
                  (soft?.introduction && soft?.introduction?.length) > 8 ? soft?.introduction : ''
                }
              >
                {soft?.introduction || ''}
              </div>
              <div
                className={styles.soft_card_infos_opt}
                ref={optRef}
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                <Button
                  soft={soft}
                  info={{
                    className: styles.soft_button,
                    className_busing: styles.soft_button_busing,
                    className_open: styles.soft_button_open,
                  }}
                  // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
                  logInfo={{ ...logInfo }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </_LogInView>
  );
});
